import { Reducer } from 'redux';
import { ActionTypes, PaidNewslettersAccountState, PaidNewslettersStripeAccountFetchSuccessAction, PaidNewslettersStripeAccountState, PaidNewslettersStripeAccountUpdateAction, PaidNewslettersStripeAccountUpdateSuccessAction } from './types';

const defaultState: PaidNewslettersStripeAccountState = {
    paidNewslettersStripeAccount: null,
    isLoading: false,
    isLoaded: false,
    isError: false,
};


const fetchState = (
    state: PaidNewslettersStripeAccountState,
    overrides: Partial<PaidNewslettersStripeAccountState>,
    payload?: PaidNewslettersAccountState
): PaidNewslettersStripeAccountState => ({
    ...state,
    ...overrides,
    paidNewslettersStripeAccount: payload ?? state.paidNewslettersStripeAccount,
});

const updateState = (
    state: PaidNewslettersStripeAccountState,
    overrides: Partial<PaidNewslettersStripeAccountState>,
    payload?: {
        ReturnUrl?: string, 
        RefreshUrl?: string
    }
): PaidNewslettersStripeAccountState => ({
    ...state,
    ...overrides,
    ...payload
})

const fetchStart = (state: PaidNewslettersStripeAccountState): PaidNewslettersStripeAccountState =>
    fetchState(state, { isLoading: true, isLoaded: false, isError: false });

const fetchSuccess = (state: PaidNewslettersStripeAccountState, action: PaidNewslettersStripeAccountFetchSuccessAction): PaidNewslettersStripeAccountState =>
    fetchState(state, { isLoading: false, isLoaded: true, isError: false }, action.payload.paidNewslettersStripeAccount);

const fetchError = (state: PaidNewslettersStripeAccountState): PaidNewslettersStripeAccountState =>
    fetchState(state, { isLoading: false, isLoaded: false, isError: true });

const updateStart = (state: PaidNewslettersStripeAccountState, action: PaidNewslettersStripeAccountUpdateAction): PaidNewslettersStripeAccountState =>
    updateState(state, { isLoading: true, isLoaded: false, isError: false }, action.payload);

const updateSuccess = (state: PaidNewslettersStripeAccountState): PaidNewslettersStripeAccountState =>
    updateState(state, { isLoading: false, isLoaded: true, isError: false });

const updateError = (state: PaidNewslettersStripeAccountState): PaidNewslettersStripeAccountState =>
    updateState(state, { isLoading: false, isLoaded: false, isError: true });


const handlers = {
    [ActionTypes.FETCH_START]: fetchStart,
    [ActionTypes.FETCH_SUCCESS]: fetchSuccess,
    [ActionTypes.FETCH_ERROR]: fetchError,
    [ActionTypes.UPDATE_START]: updateStart,
    [ActionTypes.UPDATE_SUCCESS]: updateSuccess,
    [ActionTypes.UPDATE_ERROR]: updateError,
};

const reducer: Reducer<PaidNewslettersStripeAccountState> = (
    state: PaidNewslettersStripeAccountState = defaultState,
    action
): PaidNewslettersStripeAccountState => {
    const handler = handlers[action.type];
    return handler ? handler(state, action) : state;
};

export { reducer as paidNewslettersStripeAccount };

export default reducer;
